import { render, staticRenderFns } from "./schedule.vue?vue&type=template&id=38ead593&scoped=true"
import script from "./schedule.vue?vue&type=script&lang=js"
export * from "./schedule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ead593",
  null
  
)

export default component.exports